<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-12">
          <h6 class="h2 text-white d-inline-block mb-0">Lote</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--6">
      <card>
        <template slot="header">
          <div class="row align-items-center">
            <div class="col-md-6">
              <h3 class="mb-0">Ubicación de Lotes</h3>
            </div>
            <div v-if="loaded" class="col-md-3">
              <base-input v-model="searchQuery" placeholder="Buscar..." prepend-icon="fas fa-search"></base-input>
            </div>
            <div class="col-md-3 text-right">
              <span v-if="!loaded" class="blink_me font-weight-400 mx-5">
                Cargando lotes&nbsp;&nbsp;<i class="fas fa-spin fa-circle-notch"></i
              ></span>
              <campaign-select
                v-else
                v-model="campaignSelected"
                :required="false"
                :label="null"
                :all-filter="'Todas las campañas'"
              />
            </div>
          </div>
        </template>

        <plot-locations
          ref="plotLocations"
          map-id="plots-list-map"
          :plots="plots"
          :info-window-data="infoWindow"
          :zoom="6"
          entity-type="listado de lotes"
          @mapLoaded="loadMapData(1)"
        ></plot-locations>
      </card>
    </div>
  </div>
</template>

<script>
import CampaignSelect from '@/components/ModelSelects/CampaignSelect';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import PlotLocations from './Map/Locations';

export default {
  components: {
    RouteBreadCrumb,
    PlotLocations,
    CampaignSelect,
  },

  data() {
    return {
      perPage: 10,
      lastPage: null,
      loaded: false,
      plots: [],
      campaignSelected: null,
      searchQuery: null,
    };
  },

  watch: {
    campaignSelected() {
      if (this.loaded) {
        this.$refs.plotLocations.clearMarkers();
        this.loaded = false;
        this.loadMapData(1);
      }
    },

    searchQuery(value) {
      const query = value;

      setTimeout(() => {
        if (this.searchQuery === query && this.loaded) {
          this.$refs.plotLocations.clearMarkers();
          this.loaded = false;
          this.loadMapData(1);
        }
      }, 1000);
    },
  },

  created() {
    this.searchQuery = this.$store.state.navigation.plotSearch || null;
    this.campaignSelected = this.$store.state.navigation.campaignId;
  },

  beforeDestroy() {
    this.$loader.enable();
  },

  methods: {
    infoWindow(plot, marker) {
      let seller = '',
        distributor = '',
        producer = '',
        city = '',
        address = '';
      let performance = '';

      if (plot.harvest && plot.harvest.storagePerformance) {
        performance = `<p class="my-2">${plot.harvest.storagePerformance} kg/ha</p>`;
      }
      if (plot.harvest && plot.harvest.harvestPerformance) {
        performance += `<p class="my-2">${plot.harvest.harvestPerformance} mv/ha</p>`;
      }
      let campaign = plot.campaign ? plot.campaign.name : '';
      let variety = plot.variety ? plot.variety.name : '';

      if (plot.field && plot.field.producer) {
        city = plot.field.city ? plot.field.city.name : '';
        producer = plot.field.producer.businessName;
        if (plot.field.producer.distributor) {
          distributor = plot.field.producer.distributor.name;
          if (plot.field.producer.distributor.seller) {
            seller = plot.field.producer.distributor.seller.name;
          }
        }
      }

      if (marker.info) {
        address = [...[city], ...marker.info.formatted_address.split(',')]
          .map((i) => i.trim())
          .filter((a, index, self) => !a.trim().startsWith('Unnamed') && self.indexOf(a) === index)
          .join(', ');
      } else {
        address = city;
      }

      const lat = plot.latitude;
      const lng = plot.longitude;

      const showPlot = (!plot.isShare && this.$can('show', 'plots')) || (plot.isShare && plot.read) ? '' : 'd-none';

      return `
          <h5>${producer}</h5>
          <p class="text-sm mb-0">${distributor}</p>
          <p class="text-sm">${seller}</p>
          <p class="border-top border-light mt-2 mb-0 pt-1">Campaña ${campaign}</p>
          <p class="text-sm font-italic mb-0">${variety}</p>
          ${performance}
          <p class="small mb-0">${address}</p>
          <hr class="m-1">
          <p class="mb-0 small">
            <span>${lat},${lng}</span>
            <a href='/plots/${plot.id}' class="btn btn-sm btn-success mt-1 btn-block ${showPlot}">Ver Lote</a>
          </p>
        `;
    },

    loadMapData(page) {
      this.fetchPlots(page)
        .then((res) => res.data)
        .then(({ meta, data }) => {
          if (this.lastPage === null) {
            this.$loader.disable();
            this.lastPage = meta.last_page;
          }

          this.plots = this.plots.concat(data.plots);

          if (meta.current_page + 1 <= meta.last_page) {
            this.loadMapData(meta.current_page + 1);
          } else {
            this.loaded = true;
          }
        });
    },

    fetchPlots(page) {
      return this.$services.resource('plots').get({
        perPage: this.perPage,
        page: page,
        include: ['harvest', 'campaign', 'variety', 'field.city', 'field.producer.distributor.seller'],
        'filter[campaign]': this.campaignSelected,
        'filter[hasLatLng]': true,
        'filter[search]': this.searchQuery,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.blink_me {
  animation: blinker 1s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}

::v-deep .form-group {
  margin-bottom: 0;
}
</style>
